var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import { OutsourceSettleService } from "~/services/management-service/outsource-settle.service";
var AddSettle = /** @class */ (function (_super) {
    __extends(AddSettle, _super);
    function AddSettle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            outsourceId: '',
            outsourceName: '',
            strategyName: '',
            commonState: 'ENABLED',
            commissionName: '',
            commissionId: '',
            id: ''
        };
        _this.rules = {
            outsourceId: [{ required: true, message: "该项不能为空", trigger: "blur" }],
            strategyName: [
                { required: true, message: "该项不能为空", trigger: "blur" }
            ],
            commonState: [{ required: true, message: "该项不能为空", trigger: "blur" }],
            commissionName: [
                { required: true, message: "该项不能为空", trigger: "blur" }
            ],
            strategyId: [{ required: true, message: "该项不能为空", trigger: "change" }]
        };
        return _this;
    }
    AddSettle.prototype.refreshData = function () { };
    AddSettle.prototype.emitClose = function () { };
    AddSettle.prototype.outsourceChange = function (event) {
        var _this = this;
        var out = this.outSourceList.find(function (v) { return v.id === _this.model.outsourceId; });
        this.model.outsourceName = out ? out.outsName : '';
    };
    AddSettle.prototype.commissionChange = function () {
        var _this = this;
        var commission = this.commissionSet.find(function (v) { return v.id === _this.model.commissionId; });
        this.model.commissionName = commission ? commission.strategyName : '';
    };
    /**
     * 确认
     */
    AddSettle.prototype.commit = function () {
        var _this = this;
        // 查看直接结束
        if (this.dialogType === "VIEW") {
            this.emitClose();
            return;
        }
        var form = this.$refs['add-settle'];
        var action = this.dialogType === "ADD" ? 'addSettlementStrategy' : 'updateSettlementStrategy';
        form.validate(function (v) {
            if (!v)
                return;
            _this.outsourceSettleService[action](_this.model).subscribe(function () {
                _this.$message.success("操作成功!");
                form.resetFields();
                _this.refreshData();
                _this.emitClose();
            });
        });
    };
    /**
     * 取消
     */
    AddSettle.prototype.cancle = function () {
        this.emitClose();
    };
    /**
     * 表单重置
     */
    AddSettle.prototype.refresh = function () {
        if (this.dialogType === "ADD") {
            this.model.outsourceId = '';
            this.model.strategyName = '';
            this.model.commonState = 'ENABLED';
            this.model.commissionId = '';
            this.model.id = '';
        }
        else {
            this.model.outsourceId = this.rowData.outsourceId;
            this.model.strategyName = this.rowData.strategyName;
            this.model.commonState = this.rowData.commonState;
            this.model.commissionId = this.rowData.commissionId;
            this.model.id = this.rowData.id;
        }
    };
    Object.defineProperty(AddSettle.prototype, "isDisable", {
        /**
         * 是否可编辑
         */
        get: function () {
            return this.dialogType === "VIEW";
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Dependencies(OutsourceSettleService)
    ], AddSettle.prototype, "outsourceSettleService", void 0);
    __decorate([
        State
    ], AddSettle.prototype, "outSourceList", void 0);
    __decorate([
        Prop({ required: true, type: String })
    ], AddSettle.prototype, "dialogType", void 0);
    __decorate([
        Prop({ default: [] })
    ], AddSettle.prototype, "commissionSet", void 0);
    __decorate([
        Prop()
    ], AddSettle.prototype, "rowData", void 0);
    __decorate([
        Emit("refreshData")
    ], AddSettle.prototype, "refreshData", null);
    __decorate([
        Emit("close")
    ], AddSettle.prototype, "emitClose", null);
    __decorate([
        Watch("model.outsourceId", { deep: true })
    ], AddSettle.prototype, "outsourceChange", null);
    __decorate([
        Watch("model.commissionName", { deep: true })
    ], AddSettle.prototype, "commissionChange", null);
    AddSettle = __decorate([
        Component({
            components: {}
        })
    ], AddSettle);
    return AddSettle;
}(Vue));
export default AddSettle;
